import ApiModel           from '@widesk-core/models/ApiModel';
import { Box }            from '@chakra-ui/react';
import { Separator }      from '@chakra-ui/react';

interface IListItemProps<T extends ApiModel> {
	index: number;
	item: T
	listLength: number;
	renderRow: (model: T) => JSX.Element;
	onClick?: (model: T) => void;
	options?: {
		clickable?: boolean;
		itemsMargin?: string;
		itemsPadding?: string;
		withSeparators?: boolean;
	}
}

const ListItem = <T extends ApiModel>(props: IListItemProps<T>) => {
	const { index, item, listLength, onClick, options, renderRow } = props;

	return (
		<Box>
			{
				options?.withSeparators ?
				<>
					<Box 
						borderRadius="8px"
						margin={options?.itemsMargin} 
						padding={options?.itemsPadding} 
						transition="background 0.4s ease-in-out" 
						_hover={{ cursor: options.clickable ? "pointer" : "unset", bg: options.clickable ? "beigeLight" : "unset" }}
						onClick={() => onClick && onClick(item)}
					>
						{renderRow(item)}
					</Box>
					{
						index !== listLength - 1 && 
						<Separator />
					}
				</>
				:
				<Box 
					borderRadius="8px"
					margin={options?.itemsMargin} 
					padding={options?.itemsPadding} 
					transition="background 0.4s ease-in-out" 
					_hover={{ cursor: onClick ? "pointer" : "unset", bg: "beigeLight" }}
					onClick={() => onClick && onClick(item)}
				>
					{renderRow(item)}
				</Box>
			}
		</Box>
	);
};

export default ListItem;